import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'

import React from 'react'

import clsx from 'clsx'
import './ApplyV2ReviewApplySkills.scss'
import { useTranslation } from 'react-i18next'

const baseClass = 'ApplyV2ReviewApplySkills'

interface Props {
    className?: string
    isShowExpandButton?: boolean
}

function ApplyV2ReviewApplySkills({ className = '' }: Props) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const { t } = useTranslation()
    const data = postProfileData?.data?.skill || []
    const isEmpty = data.length === 0

    return (
        <div
            className={clsx(baseClass, className, {
                [`${baseClass}--isEmpty`]: isEmpty,
            })}
        >
            {isEmpty ? (
                <div>{t('10706', 'No skills added')}</div>
            ) : (
                data.map((skill) => (
                    <div key={skill.existingId || skill.uid} className={`${baseClass}__item`}>
                        {skill.skill}
                    </div>
                ))
            )}
        </div>
    )
}

export default ApplyV2ReviewApplySkills
